/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDesk = createReactComponent("outline", "desk", "IconDesk", [["path", { "d": "M3 6h18", "key": "svg-0" }], ["path", { "d": "M4 6v13", "key": "svg-1" }], ["path", { "d": "M20 19v-13", "key": "svg-2" }], ["path", { "d": "M4 10h16", "key": "svg-3" }], ["path", { "d": "M15 6v8a2 2 0 0 0 2 2h3", "key": "svg-4" }]]);

export { IconDesk as default };
//# sourceMappingURL=IconDesk.mjs.map
